(() => {
  const initialize = root => {
    root.querySelectorAll('.arnav-footer').forEach(footer => {
      if (footer.dataset.accordionsReady) return;
      footer.dataset.accordionsReady = 'true';
      const media = window.matchMedia('(max-width: 768px)');
      const groups = [...footer.querySelectorAll('.arnav-footer-disclosure')];
      const update = () => groups.forEach(group => {
        group.open = !media.matches;
        const summary = group.querySelector('summary');
        summary.tabIndex = media.matches ? 0 : -1;
        if (media.matches) summary.removeAttribute('aria-disabled');
        else summary.setAttribute('aria-disabled', 'true');
      });
      groups.forEach(group => group.querySelector('summary').addEventListener('click', event => {
        if (!media.matches) event.preventDefault();
      }));
      media.addEventListener('change', update);
      update();
      const cleanup = event => {
        if (!event.target.contains(footer)) return;
        media.removeEventListener('change', update);
        document.removeEventListener('shopify:section:unload', cleanup);
      };
      document.addEventListener('shopify:section:unload', cleanup);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
